"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlCartesianUpdateHooks = void 0;
/**
 * @public
 * Canvas update hook, called before and after a plot is drawn.
 */
class GlCartesianUpdateHooks {
    constructor(getDrawRange) {
        this.getDrawRange = getDrawRange;
    }
    onBeforeUpdate(renderer, arg) {
        renderer.sharedState.updateScissorRange(this.getDrawRange(arg));
    }
    onAfterUpdate() {
        // no action needed
    }
}
exports.GlCartesianUpdateHooks = GlCartesianUpdateHooks;
//# sourceMappingURL=gl-cartesian-update-hooks.js.map